import { render, staticRenderFns } from "./invoice-options-mark-as-paid.vue?vue&type=template&id=22cbf34b&scoped=true"
import script from "./invoice-options-mark-as-paid.vue?vue&type=script&lang=js"
export * from "./invoice-options-mark-as-paid.vue?vue&type=script&lang=js"
import style0 from "./invoice-options-mark-as-paid.vue?vue&type=style&index=0&id=22cbf34b&prod&lang=css"
import style1 from "./invoice-options-mark-as-paid.vue?vue&type=style&index=1&id=22cbf34b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cbf34b",
  null
  
)

export default component.exports